import { decimalFormat, sharesFormat } from 'common/formats/formats';

const colConfig = [
  {
    value: 'Shares',
    alias: 'shares',
    width: '100%',
    format: sharesFormat,
    minValue: 1,
    gridType: 'number',
  },
  {
    value: 'Strike Price',
    alias: 'price',
    width: '100%',
    format: {
      ...decimalFormat(),
      maximumFractionDigits: 15,
      maximumFractionDigitsWhenEditing: 15,
      style: 'currency',
    },
    greaterThan: 0,
    gridType: 'number',
  },
];

export default colConfig;
